class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.init()

    // Add resize observer to update container height
    const resizeObserver = new ResizeObserver(entries => {
      this.update()
    });
    resizeObserver.observe(this);

    // Bind event listeners
    this.navItems.forEach(item => item.addEventListener('click', this.onNavItemClick.bind(this)))
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    // Listen for variant selection change to make current variant image active
    window.addEventListener('message', this.onVariantChange.bind(this))

    this.touchstartX = 0
    this.touchendX = 0

    window.addEventListener('touchstart', e => {
      this.touchstartX = e.changedTouches[0].screenX
    })

    window.addEventListener('touchend', e => {
      this.touchendX = e.changedTouches[0].screenX
      this.swipe()
    })

  }

  init() {
    document.addEventListener("DOMContentLoaded", () => {
      // Set up our DOM element variables
      this.imagesContainer = this.querySelector('.product-gallery__images');
      this.navItems = this.querySelectorAll('.product-gallery__nav-item');
      this.images = this.querySelectorAll('.product-gallery__image');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      // If there is no active images set the first image to active
      if (this.findCurrentIndex() === -1) {
        if(this.images[0]) {
          this.setCurrentImage(this.images[0])
        }
      }
    })


  }

  swipe() {
    if (this.touchendX < this.touchstartX) {
      this.prevButton.click()
    }
    if (this.touchendX > this.touchstartX) {
      this.nextButton.click()
    }
  }

  onVariantChange(event) {
    if (!event.data || event.data.type !== 'variant_changed') return
    const currentImage = Array.from(this.images).find(item => item.dataset.mediaId == event.data.variant.featured_media.id)
    if (currentImage) {
      this.setCurrentImage(currentImage)
    }
  }

  onNavItemClick(event) {
    const mediaId = event.target.closest('li').dataset.mediaId
    this.images.forEach(item => item.classList.remove('product-gallery__image--active'))
    this.setCurrentImage(Array.from(this.images).find(item => item.dataset.mediaId === mediaId))
  }

  update() {
    //this.style.height = `${this.imagesContainer.offsetHeight-150}px`
    this.prevButton.removeAttribute('disabled')
    this.nextButton.removeAttribute('disabled')
    if (this.findCurrentIndex() === 0) this.prevButton.setAttribute('disabled', true)
    if (this.findCurrentIndex() === this.images.length - 1) this.nextButton.setAttribute('disabled', true)
  }

  setCurrentImage(elem) {
    if (elem) {
      this.images.forEach(item => item.classList.remove('product-gallery__image--active'))
      elem.classList.add('product-gallery__image--active')
      this.update()
      this.playCurrentVideo(elem)

    }
  }
  playCurrentVideo(elem) {
    const elems = document.querySelectorAll('.js-video')
    if(!elems) return false
    elems.forEach(elem => {
      elem.querySelector(".js-video-action").classList.replace("play", "stop")
      elem.querySelector("video").pause()
      elem.querySelector("video").muted = true
      if(elem.querySelector('.js-video-mute')) elem.querySelector('.js-video-mute').classList.add("mute")
    })

    if(elem.querySelector('.js-video')) {
      elem.querySelector(".js-video-action").classList.replace("stop", "play")
      elem.querySelector("video").play()
      elem.querySelector("video").muted = true
      elem.querySelector('.js-video-mute').classList.add("mute")
    }
  }

  findCurrentIndex() {
    return Array.from(this.images).findIndex(item => item.classList.contains('product-gallery__image--active'))
  }
  onButtonClick(event) {
    event.preventDefault();
    let index = this.findCurrentIndex()
    if (event.currentTarget.name === 'next') {
      index++
    } else {
      index--
    }
    this.setCurrentImage(this.images[index])
  }
}

customElements.define('product-gallery', ProductGallery);
